module.exports = __webpack_public_path__ + "img/zones.6083413a.svg";